import { createFileRoute, redirect } from '@tanstack/react-router'

import { PortalSpecReader } from '@/components/portal/portal-spec-reader'
import { matching, readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/portal/projets/$projectId_/cahier/')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /**
         * 1.76.0 : le lien du courriel d'un chapitre envoyé. La validation du
         * chapitre est sur la page du projet : on y mène, chapitre déplié.
         */
        chapitre: matching(/^[0-9a-f]{24}$/),
      },
      search,
    ),
  beforeLoad: ({ params, search }) => {
    if (!search.chapitre) return
    throw redirect({
      to: '/portal/projets/$projectId',
      params: { projectId: params.projectId },
      search: { chapitre: search.chapitre },
      replace: true,
    })
  },
  component: PortalSpecReaderRoute,
})

function PortalSpecReaderRoute() {
  const { projectId } = Route.useParams()
  return <PortalSpecReader projectId={projectId} />
}
